import { OrganisationManageableRole, Role } from '../../types/auth/role';

export const canManageOrganisationMembers = (role?: Role | null) =>
  role === 'ORG_ADMIN' || role === 'ADMIN';

export const canManageBilling = (role?: Role | null) =>
  role === 'ORG_ADMIN' || role === 'ADMIN';

export const canManageAudit = (role?: Role | null) =>
  role === 'ORG_ADMIN' || role === 'ADMIN';

export const normalizeManageableRole = (
  role?: Role | null,
): OrganisationManageableRole => (role === 'ORG_ADMIN' ? 'ORG_ADMIN' : 'ORG_MEMBER');
